import { connect } from 'react-redux';

import {
  getAllFavoriteQuestions,
  getSubmittedQuestions,
} from '../actions/accountSettingsAction';
import { openPdfViewer } from '../actions/dashboardActions';
import { disableQuestion } from '../actions/helpPopupsActions';
import { activateSubscription } from '../actions/manageSubscriptionActions';
import {
  addCountQuestions,
  breadcrumsAction,
  checkChapterInReviewAction,
  cleanQuestions,
  favoriteQuestion,
  getPdfByReference,
  getQuestionByMySubmittedQuestions,
  getQuestionsByChapter,
  getQuestionsByFavoriteQuestions,
  getQuestionsByMyFavoriteQuestions,
  getQuestionsByPersonalizedStudyAll,
  getQuestionsByQuals,
  getQuestionsByRate,
  getQuestionsBySubmittedQuestions,
  previousCountersToActual,
  previousQuestionToActual,
  resetChapterAction,
  sendAnswer,
  setAnswerResponse,
  setBackedStateToQuestion,
  setCountQuestions,
  setFavoriteMessage,
  setIsLoadingQuestions,
  setIsStudyFavoriteQuestion,
  setIsStudyingMyFavoriteQuestions,
  setIsStudyingMySubmittedQuestions,
  setIsStudyingSubmittedQuestions,
  setPreviousCounters,
  setPreviousQuestion,
  setQuestion,
  setRecaptchaTime,
  updateCounters,
  updateUserAnswers,
} from '../actions/studyMainActions';
import { setCantStudy, trialUserProgress } from '../actions/userActions';
import {
  favoriteListQuestionsSelector,
  getFlashcardOnly,
  getSwitchPfeSkt,
  getUserSubscription,
  loadingFavoriteQuestionsSelector,
} from '../components/AccountSettings/AccountSettingsSelectors';
import { getShowPdfViewer } from '../components/Dashboard/dashboardSelectors';
import {
  getSubscriptionActivationMessage,
  getSubscriptionActivationSuccess,
  getSubscriptionActivationWaiting,
} from '../components/ManageSubscription/ManageSubscriptionSelectors';
import QuestionContainer from '../components/Question/QuestionContainer.jsx';
import {
  errorMessageGetQuestionSelector,
  getAnswerResponse,
  getBackToSelector,
  getBreadcrums,
  getCountersSelector,
  getCountQuestions,
  getLoadResetChapter,
  getPdfLink,
  getPreviousCountersSelector,
  getPreviousQuestionSelector,
  getQuestionsDataSelector,
  getQuestionSelector,
  getRecaptchaTime,
  getResetChapter,
  isLoadingQuestionsSelector,
  isStudyFavoriteQuestionSelector,
  isStudyingMyFavoriteQuestionsSelector,
  isStudyingMySubmittedQuestionsSelector,
  isStudyingSubmittedQuestionsSelector,
  loadFavoriteQuestionSelector,
  setFavoriteMessageSelector,
  submittedListQuestionsSelector,
} from '../components/Study/studyMainSelectors'; // SELECTORS
import { getCantStudy, getUser } from '../components/User/userSelectors';
import { verifyLoggedUser } from '../utils/verifyUserLogged';

const mapStateToProps = (state) => ({
  // Reducer state with the main information
  questionsData: getQuestionsDataSelector(state),
  question: getQuestionSelector(state),
  previousQuestion: getPreviousQuestionSelector(state),
  previousCounters: getPreviousCountersSelector(state),
  counters: getCountersSelector(state),
  isLoadingQuestions: isLoadingQuestionsSelector(state),
  errorMessageGetQuestion: errorMessageGetQuestionSelector(state),
  user: getUser(state),
  backTo: getBackToSelector(state),
  getCountQuestions: getCountQuestions(state),
  getRecaptchaTime: getRecaptchaTime(state),
  flashcard: getFlashcardOnly(state),
  userSubscription: getUserSubscription(state),
  answerResponse: getAnswerResponse(state),
  subscriptionActivationMessage: getSubscriptionActivationMessage(state),
  subscriptionActivationWaiting: getSubscriptionActivationWaiting(state),
  subscriptionActivationSucces: getSubscriptionActivationSuccess(state),
  cantStudy: getCantStudy(state),
  pdfLink: getPdfLink(state),
  pfeSktId: getSwitchPfeSkt(state),
  showPdfViewer: getShowPdfViewer(state),
  breadcrumsQualsAndCerts: getBreadcrums(state),
  loadFavoriteQuestion: loadFavoriteQuestionSelector(state),
  setFavoriteMessage: setFavoriteMessageSelector(state),
  listFavoriteQuestions: favoriteListQuestionsSelector(state),
  listSubmittedQuestions: submittedListQuestionsSelector(state),
  isStudyingFavoriteQuestions: isStudyFavoriteQuestionSelector(state),
  isStudyingMyFavoriteQuestions: isStudyingMyFavoriteQuestionsSelector(state),
  isStudyingSubmittedQuestions: isStudyingSubmittedQuestionsSelector(state),
  isStudyingMySubmittedQuestions: isStudyingMySubmittedQuestionsSelector(state),
  loadingFavoriteQuestions: loadingFavoriteQuestionsSelector(state),
  loadResetChapter: getLoadResetChapter(state),
  resetChapter: getResetChapter(state),
});

const mapDispatchToProps = (dispatch) => ({
  // These are the main functions to get the study items.
  getQuestionsByRate: (stackedQuestions, isSetQuestion) => {
    dispatch(getQuestionsByRate(stackedQuestions, isSetQuestion));
  },
  getQuestionsByPersonalizedStudyAll: (
    studyProgram,
    stackedQuestions,
    isSetQuestion,
  ) => {
    dispatch(
      getQuestionsByPersonalizedStudyAll(
        studyProgram,
        stackedQuestions,
        isSetQuestion,
      ),
    );
  },

  getQuestionsByChapter: (
    chapter,
    studyProgram,
    stackedQuestions,
    isSetQuestion,
  ) => {
    dispatch(
      getQuestionsByChapter(
        chapter,
        studyProgram,
        stackedQuestions,
        isSetQuestion,
      ),
    );
  },

  getQuestionsByQuals: (
    qual,
    studyProgram,
    stackedQuestions,
    isSetQuestion,
  ) => {
    dispatch(
      getQuestionsByQuals(qual, studyProgram, stackedQuestions, isSetQuestion),
    );
  },

  getQuestionsByFavoriteQuestions: (stackedQuestions, isSetQuestion) => {
    dispatch(getQuestionsByFavoriteQuestions(stackedQuestions, isSetQuestion));
  },

  getQuestionsByMyFavoriteQuestions: (stackedQuestions, isSetQuestion) => {
    dispatch(
      getQuestionsByMyFavoriteQuestions(stackedQuestions, isSetQuestion),
    );
  },

  getQuestionByMySubmittedQuestions: (stackedQuestions, isSetQuestion) => {
    dispatch(
      getQuestionByMySubmittedQuestions(stackedQuestions, isSetQuestion),
    );
  },

  getQuestionsBySubmittedQuestions: (stackedQuestions, isSetQuestion) => {
    dispatch(getQuestionsBySubmittedQuestions(stackedQuestions, isSetQuestion));
  },

  cleanQuestions: () => {
    dispatch(cleanQuestions());
  },

  sendAnswer: (answer) => {
    dispatch(sendAnswer(answer));
  },
  favoriteQuestion: (questionId, addToFavorites, userId) => {
    dispatch(favoriteQuestion(questionId, addToFavorites, userId));
  },

  setQuestion: (question, questionsData) => {
    dispatch(setQuestion(question, questionsData));
  },

  setPreviousQuestion: (question) => {
    dispatch(setPreviousQuestion(question));
  },

  setPreviousCounters: (counters) => {
    dispatch(setPreviousCounters(counters));
  },

  previousQuestionToActual: () => {
    dispatch(previousQuestionToActual());
    dispatch(previousCountersToActual());
  },

  setBackedStateToQuestion: () => {
    dispatch(setBackedStateToQuestion());
  },

  updateCounters: (answ) => {
    dispatch(updateCounters(answ, null));
  },

  setIsLoadingQuestions: (isLoadingQuestions) => {
    dispatch(setIsLoadingQuestions(isLoadingQuestions));
  },

  disableQuestion: (questionId, chapterId) => {
    dispatch(disableQuestion(questionId, chapterId));
  },
  openPdfViewer: (value) => {
    dispatch(openPdfViewer(value));
  },
  verifyLoggedUser: () => {
    verifyLoggedUser();
  },
  setCountQuestions: (value) => {
    dispatch(setCountQuestions(value));
  },
  addCountQuestions: (value) => {
    dispatch(addCountQuestions(value));
  },
  setRecaptchaTime: (value) => {
    dispatch(setRecaptchaTime(value));
  },
  updateUserAnswers: (value) => dispatch(updateUserAnswers(value)),
  checkChapterInReview: (value) => dispatch(checkChapterInReviewAction(value)),

  getPdfByReference: (payload) => dispatch(getPdfByReference(payload)),

  clearAnswerResponse: () => dispatch(setAnswerResponse('')),
  activateSubscription: () => {
    dispatch(activateSubscription());
  },
  setCantStudy: (value) => dispatch(setCantStudy(value)),
  getTrialUserProgress: (studyId, studyMethod) =>
    dispatch(trialUserProgress(studyId, studyMethod)),
  breadcrumsQualsAndCertsAction: (breadcrums) =>
    dispatch(breadcrumsAction(breadcrums)),
  setFavoriteMessageAction: (status) => dispatch(setFavoriteMessage(status)),
  getAllFavoriteQuestions: () => dispatch(getAllFavoriteQuestions()),
  setIsStudyFavoriteQuestion: (status) =>
    dispatch(setIsStudyFavoriteQuestion(status)),
  getSubmittedQuestions: () => dispatch(getSubmittedQuestions()),
  setIsStudyingMyFavoriteQuestions: (status) =>
    dispatch(setIsStudyingMyFavoriteQuestions(status)),
  setIsStudyingSubmittedQuestions: (status) =>
    dispatch(setIsStudyingSubmittedQuestions(status)),
  setIsStudyingMySubmittedQuestions: (status) =>
    dispatch(setIsStudyingMySubmittedQuestions(status)),
  setResetChapter: (value) => dispatch(resetChapterAction(value)),
});

const QuestionDataContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuestionContainer);

export default QuestionDataContainer;
